<script setup lang="ts">
import { VButton, VIcon } from '@/modules/shared/components'

const checked = defineModel<boolean>({ required: true })
defineProps<{ disabled?: boolean }>()
</script>

<template>
  <div class="relative inline-block">
    <VButton
      class="h-4 w-4 !p-0"
      :class="checked ? '!bg-gray-200 text-gray-400 opacity-50 ring-1 ring-gray-200/20' : ''"
      :disabled="disabled"
      @click="!disabled && (checked = !checked)"
    />
    <Transition name="check" appear>
      <span v-if="checked" class="pointer-events-none absolute inset-0 flex items-center justify-center p-0.5 text-sm">
        <VIcon name="Check" class="h-full w-full" />
      </span>
    </Transition>
  </div>
</template>

<style scoped>
.check-enter-active,
.check-leave-active {
  @apply transition-all duration-150 ease-out;
}
.check-enter-from,
.check-leave-to {
  @apply scale-50 opacity-0;
}
</style>
